// import pages/components
import Home from "./views/Home.vue";
import PageNotFound from "./views/404.vue";
import SharedPage from "./views/Shared.vue";

// site title, description, & general info
/**
 * @type {String} website title
 */
const title = "حصن مسلم";
/**
 * @type {String} website author
 */
const author = "Mohssine Aboutaj";

// links & routes
/**
 * @type {Array} all routes in the application
 *
 * @property {String} icon icon to show aside to the route title
 * @property {String} title title of the route
 * @property {String} path path of the route
 * @property {Function} component import component
 * @property {Boolean} hidden hidden from navbar or any navigation bar
 */
let links = [
  {
    icon: "home",
    title: "Home",
    path: "/",
    component: Home,
  },
  {
    icon: "heart",
    title: "Favourite",
    path: "/favourite",
    component: () => {
      return import(
        /* @vite-ignore */
        /* webpackChunkName: "Favourite" */
        `./views/Favourite.vue`
      );
    },
  },
  {
    icon: "question-circle",
    title: "About",
    path: "/about",
    component: () => {
      return import(
        /* @vite-ignore */
        /* webpackChunkName: "About" */
        `./views/About.vue`
      );
    },
  },
  {
    icon: "cogs",
    title: "Settings",
    path: "/settings",
    component: () => {
      return import(
        /* @vite-ignore */
        /* webpackChunkName: "Settings" */
        `./views/Settings.vue`
      );
    },
  },
  {
    hidden: true,
    title: "Dikr",
    path: "/dikr/:slug",
    component: () => {
      return import(
        /* @vite-ignore */
        /* webpackChunkName: "Dikr" */
        `./views/Dikr.vue`
      );
    },
  },
  {
    hidden: true,
    path: "/shared",
    name: "shared",
    component: SharedPage,
  },
  {
    hidden: true,
    path: "/404",
    name: "PageNotFound",
    component: PageNotFound,
  },
];

// exporting
export { title, links, author };
